import { FC, SVGProps } from "react";

interface HelpIconProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  color?: string;
}

const HelpIcon: FC<HelpIconProps> = ({
  width = 24,
  height = 24,
  color = "#048CDD",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 8.96703C9 7.32839 10.3431 6 12 6C13.6568 6 15 7.32839 15 8.96703C15 9.93761 14.5288 10.7994 13.8003 11.3407C13.2988 11.7133 12 12.5275 12 14.3077"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="12" cy="12" r="11" stroke={color} strokeWidth="2" />
      <path
        d="M11.9998 19.2C12.6625 19.2 13.1998 18.6627 13.1998 18C13.1998 17.3373 12.6625 16.8 11.9998 16.8C11.3371 16.8 10.7998 17.3373 10.7998 18C10.7998 18.6627 11.3371 19.2 11.9998 19.2Z"
        fill={color}
      />
    </svg>
  );
};

export default HelpIcon;
